<template>
  <div class="inbound_box">
    <div class="calls_title">{{ lang.an_audio_call }}</div>
    <div class="calls_list">
      <div class="calls_list_item" v-for="(call, idx) in callsList" :key="idx">
        <!-- 个人信息 -->
        <div class="profile">
          <!-- 头像 -->
          <div class="avatar">
            <el-avatar :src="computedLogo(call)"></el-avatar>
          </div>
          <!-- 姓名和电话号码 -->
          <div class="name_phone">
            <!-- 姓名 -->
            <div class="name">
              {{ computedName(call) }}
            </div>
            <div class="phone">
              <!-- 来电号码 -->
              <div class="call_phone">
                {{ computedPhone(call) }}
              </div>
              <!-- 转送号码 -->
              <div class="transfer_phone" v-if="isTransferPhone(call)">
                {{ `(${computedTransferCall(call)}から転送)` }}
              </div>
            </div>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="call_btn">
          <!-- 接听按钮 -->
          <div class="btn_item answer"  v-if = "getCallStatus(call) != 'started'" @click="handleAnswerButtonClick(call)">
            <font-awesome-icon :icon="['fas', 'phone']" />
          </div>
          <!-- 拒接按钮 -->
          <div class="btn_item cancel" @click="endAudioCall(call)">
            <font-awesome-icon :icon="['fas', 'phone']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import api from "@/api";
  export default {
    name: "inbound",
    props: ["callsList", "lang"],
    computed: {
      ...mapGetters("sysInit", {
			  allUsersAndCustomers: "allUsersAndCustomers",
    	}),
    },
    methods: {
      handleAnswerButtonClick(call) {
        if (this.$store.state.sysInit.role == 'supervisor') {
          // 如果当前登录用户的角色为SV
          console.log('当前登录用户的角色为SV，需要判断是否在UC3上面开启了电话监听');
          let params = {
            telNum: this.$store.state.sysInit.tel_num,
          };
          api.searchMonitoringTelNum(params).then(res => {
            if (res.data.data) {
              if (res.data.data.monitoringTelNum) {
                // 如果当前登录用户在UC3上面正在监听某通电话
                console.log(`当前登录用户${this.$store.state.sysInit.tel_num}正在UC3上面监听${res.data.data.monitoringTelNum}`);
                // 1. 记录下点击的数据行的电话号码
                this.$store.commit('phone/updateLineNumber', call.LineNumber);
                // 2. 记录下Tnumber
                this.$store.commit('phone/updateTNumber', call.SipSession.incomingInviteRequest.message.headers.Tnumber && call.SipSession.incomingInviteRequest.message.headers.Tnumber.length && call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw ? this.$utils.asteriskHeaderArray2Json(call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum : '');
                // 3. 记录下触发器为侧边栏电话面板
                this.$store.commit('phone/updateStopMonitoringTrigger', 'PHONE_SIDE_PANEL');
                // 4. 确认是否要停止UC3上面的电话监听
                this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: true});
              } else {
                // 如果当前登录用户在UC3上面没有监听任何电话
                console.log(`当前登录用户${this.$store.state.sysInit.tel_num}未在UC3上面开启监听`);
                // 在UC2上面开始电话接听
                this.answerAudioCall(call.LineNumber, call.SipSession.incomingInviteRequest.message.headers.Tnumber && call.SipSession.incomingInviteRequest.message.headers.Tnumber.length && call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw ? this.$utils.asteriskHeaderArray2Json(call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum : '');
              }
            } else {
              // 展示错误信息
              this.$message.error('System error');
            }
          })
        } else {
          // 如果当前登录用户的角色不是SV
          console.log('当前登录用户的角色不是SV，在UC2上面直接开始电话接听');
          this.answerAudioCall(call.LineNumber, call.SipSession.incomingInviteRequest.message.headers.Tnumber && call.SipSession.incomingInviteRequest.message.headers.Tnumber.length && call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw ? this.$utils.asteriskHeaderArray2Json(call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum : '');
        }
      },
      answerAudioCall(callerNum, Tnumber){
        this.$SIP.AnswerAudioCall(callerNum)
        this.$emit('updateCallNum', Tnumber.trimStart() ? Tnumber : callerNum)
      },
      getCallStatus(call){
        if(call.SipSession.data && call.SipSession.data.started ){
          return 'started'
        }else{
          return ''
        }
      },
      endAudioCall(call){
        if(call.SipSession.data && call.SipSession.data.started ){
          this.$SIP.endSession(call.LineNumber);
        }else{
          this.$SIP.RejectCall(call.LineNumber);
        }
      },
      // 来电号码
      computedPhone(call) {
        return call.SipSession.incomingInviteRequest.message.headers.Tnumber && call.SipSession.incomingInviteRequest.message.headers.Tnumber.length && call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw ? this.$utils.asteriskHeaderArray2Json(call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw).tnum : call.LineNumber;
      },
      // 是否是转送电话
      isTransferPhone(call) {
        return call.SipSession.incomingInviteRequest.message.headers.Tnumber && call.SipSession.incomingInviteRequest.message.headers.Tnumber.length && call.SipSession.incomingInviteRequest.message.headers.Tnumber[0].raw;
      },
      // 转送号码
      computedTransferCall(call) {
        return call.LineNumber;
      },
      // 来电者头像
      computedLogo(call) {
        let logo = process.env.VUE_APP_DEFAULT_PROFILE_PHOTO;
        let userOrCustomer = _.find(this.allUsersAndCustomers, {phone: this.computedPhone(call)});
        if (userOrCustomer && userOrCustomer.logo) {
          logo = userOrCustomer.logo;
        }
        return logo;
      },
      // 来电者姓名
      computedName(call) {
        let name = "";
        let userOrCustomer = _.find(this.allUsersAndCustomers, {phone: this.computedPhone(call)});
        if (userOrCustomer) {
          name = userOrCustomer.name;
        }
        return name;
      },
    },
    watch: {
      "$store.state.phone.stopMonitoring": function(stopMonitoring) {
        // 确定要停止UC3上面的电话监听
        if (stopMonitoring) {
          // 是通过侧边栏电话面板触发的停止监听事件
          if (this.$store.state.phone.stopMonitoringTrigger == 'PHONE_SIDE_PANEL') {
            let lineNumber = this.$store.state.phone.lineNumber;
            let tNumber = this.$store.state.phone.tNumber;
            // 1. 把确认是否要停止UC3上面的电话监听的结果重置为初始状态false
            this.$store.state.phone.stopMonitoring = false;
            // 2. 把点击的数据行的来电号码重置为初始状态空字符串
            this.$store.state.phone.lineNumber = '';
            // 3. 把Tnumber重置为初始状态空字符串
            this.$store.state.phone.tNumber = '';
            let params = {
              userId: this.$store.state.sysInit.user_id,
              telNum: this.$store.state.sysInit.tel_num,
            }
            api.stopMonitoring(params).then(res => {
              if (res.data.data) {
                // 要求在UC3上面停止电话监听的Message发送成功
                // 开始在UC2上面的电话接听
                this.answerAudioCall(lineNumber, tNumber);
              } else {
                // 展示错误信息
                this.$message.error('System error');
              }
            });
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.inbound_box {
  padding: 10px 0;
  .calls_title{
    padding: 5px 0;
    font-size: 18px;
    border-bottom: 1px solid #4DB1EC;
    font-weight: bold;
  }
  .calls_list{
    .calls_list_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      row-gap: 5px;
      background: #eff5f8;
      padding: 10px;
      .profile {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .avatar {

        }
        .name_phone {
          display: flex;
          flex-direction: column;
          row-gap: 2px;
          .name {
            text-wrap: nowrap;
            font-weight: 700;
            font-size: 16px;
          }
          .phone {
            display: flex;
            flex-wrap: wrap;
            column-gap: 5px;
            .call_phone {
              font-size: 14px;
              color: #737475;
            }
            .transfer_phone {
              text-wrap: nowrap;
              font-size: 12px;
              color: #97989c;
            }
          }
        }
      }
      .call_btn {
        display: flex;
        flex-wrap: nowrap;
        .btn_item {
          margin: 0 10px;
          cursor: pointer;
          &.answer{
            color: #5D9048;
          }
          &.cancel{
            transform: rotateZ(135deg);
            color: #c80000;
          }
        }
      }
    }
  }
}
</style>